export default "__VITE_ASSET__B5c4T8$8__"